import React, { useContext } from "react";
import logoText from "../../assets/images/arcese_logo_text.svg";
import logo from "../../assets/images/arcese_logo.svg";
import notificationsIcon from "../../assets/images/icons/notifications.svg";
import ProfileDropDown from "../profileDropdown/ProfileDropDown";
import { useTranslation } from "react-i18next";
import { ActionSidebarsContext } from "../../context/actionSidebarsContext";
import { IActionSidebarsContext } from "../../types/actionSidebars";
import SwitchLanguage from "../switchLanguage/SwitchLanguage";
import { NotificationsContext } from "../../context/notificationsContext";
import { INotificationsContext } from "../../types/notifications";
import { IAccountStatusContext } from "../../types/accountStatus";
import { AccountStatusContext } from "../../context/accountStatusContext";

interface IHeaderProps {
    callbackOpenCloseSidebarMobile: () => void
}

const Header = React.forwardRef<HTMLDivElement, IHeaderProps>(({
    callbackOpenCloseSidebarMobile,
}, ref) => {

    const { t } = useTranslation();

    const { notificationsToRead } = useContext(NotificationsContext) as INotificationsContext;
    const { userHasPartialAccess } = useContext(AccountStatusContext) as IAccountStatusContext;

    const {
        setSidebarNotificationsOpen
    } = useContext(ActionSidebarsContext) as IActionSidebarsContext;

    return (
        <header className="h-[60px] bg-red px-6 md:px-8 shrink-0">
            <div className="flex justify-between items-center h-full">

                {/* Logos */}
                <div className="flex items-center">
                    {/* Burger Tablet & Mobile */}
                    <div ref={ref} onClick={callbackOpenCloseSidebarMobile} className="block lg:hidden mr-[14px] cursor-pointer">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="#FFFFFF" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                        </svg>
                    </div>

                    {/* Logos Tablet & Mobile */}
                    <img className="hidden md:block cursor-pointer select-none" src={logoText} alt="Logo Arcese con scritta" />
                    <img className="md:hidden cursor-pointer select-none" src={logo} alt="Logo Arcese" />

                    {/* Mobile Only */}
                    <div className="flex md:hidden items-center">
                        <div className="text-white text-[15px] ml-[10px]">
                            <strong className="font-black align-middle">VLM</strong>
                        </div>
                    </div>
                </div>

                <div className="hidden md:block text-white text-[15px]">
                    <strong className="font-black">{t('common.vlmAcronym')}</strong> {t('common.vlmLabel')}
                </div>

                <div className="flex items-center">
                    {/* Notifications */}
                    {
                        userHasPartialAccess === false &&
                        <div onClick={() => setSidebarNotificationsOpen(true)} className="relative cursor-pointer mr-6 md:mr-12">
                            {
                                notificationsToRead.length > 0 &&
                                <div className="h-[20px] w-[20px] leading-[20px] text-center bg-white rounded-full overflow-hidden absolute top-0 -left-[80%] text-red text-[13px] font-bold">
                                    {notificationsToRead.length}
                                </div>
                            }
                            <img className="select-none" src={notificationsIcon} alt="notifications-icon" />
                        </div>
                    }

                    <div className="mr-6 md:mr-12">
                        <SwitchLanguage positionX="left" />
                    </div>

                    <ProfileDropDown />
                </div>
            </div>
        </header>
    );
})

export default Header;